import React from 'react';
import { BoxProps } from '@withjoy/joykit';
import { ShimmerContainer } from './ShimmerAnimation.styles';

interface ShimmerAnimationProps extends BoxProps {
  readonly enabled: boolean;
  readonly children: React.ReactNode;
}

/**
 * ShimmerAnimation - Adds a shimmer overlay effect to loading content
 *
 * Use this when you want to keep content visible with a shimmer effect.
 * For placeholder loading states, use the Skeleton component instead.
 */
export const ShimmerAnimation = React.memo<ShimmerAnimationProps>(({ enabled, children, ...restProps }) => {
  return (
    <ShimmerContainer
      enabled={enabled}
      {...restProps}
    >
      {children}
    </ShimmerContainer>
  );
});

ShimmerAnimation.displayName = 'ShimmerAnimation';
